/**
 * WI-B-04 — the installed-session store. The ONE place the app holds "who is
 * signed in and what they can see" after /callback resolves. This is the seam
 * the App shell reads (ProjectContext) and the seam C-mount (visibleProjects)
 * plugs into once B lands — a verified session in, scoped current-user + config
 * out. Before a session is installed it is null (no baked bearer, no shared
 * pilot identity — that was the 2026-07-30 leak).
 */

import type { EstablishedSession } from "./workos-session";

let current: EstablishedSession | null = null;
type Listener = (s: EstablishedSession | null) => void;
const listeners = new Set<Listener>();

/** Install the session produced by a successful /callback. */
export function installSession(session: EstablishedSession): void {
  current = session;
  for (const l of listeners) l(current);
}

/** The current installed session, or null when signed out. */
export function getSession(): EstablishedSession | null {
  return current;
}

/** Clear the session on sign-out. PRESERVES the outbox — this only forgets the
 * identity; queued captures stay durably in IDB and send after re-auth. */
export function clearSession(): void {
  current = null;
  for (const l of listeners) l(null);
}

export function onSessionChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function _resetSessionStoreForTests(): void {
  current = null;
  listeners.clear();
}
